import script from "./OptimizeContract.vue?vue&type=script&setup=true&lang=js"
export * from "./OptimizeContract.vue?vue&type=script&setup=true&lang=js"

import "./OptimizeContract.vue?vue&type=style&index=0&id=171e19f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-171e19f7"]])

export default __exports__